import DocumentTableItemTags from './DocumentTableItemTags';

export default DocumentTableItemTags;
